import { Pipe, PipeTransform } from '@angular/core';
import { QueueViewColumn } from '../../models/column.interface';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'appColumnSortBy'
})
export class ColumnSortByPipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {
  }

  transform(items: QueueViewColumn[], sortBy: string): QueueViewColumn[] {
    if (sortBy === 'name') {
      return items.slice(0).sort((a, b) => {
        const aName = this._translateService.instant(a.displayName);
        const bName = this._translateService.instant(b.displayName);
        return aName.localeCompare(bName);
      });
    }
    return items;
  }
}
